module.exports = __webpack_public_path__ + "img/prize.7fcf554e.png";